import { CSSProperties } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import skillsChartPNG from '~/assets/images/communication/skills-chart.png'
import skillsChartWEBP from '~/assets/images/communication/skills-chart.webp'
import { SkillsChartCommunicationStyles as S } from '~/pages/communication/skillsChart/libs/components/SkillsChartCommunication/styles'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

const QUESTION = 'One skill unlocks them all'

interface IStat {
  key: string
  style: CSSProperties
}

const STATS: IStat[] = [
  {
    key: 'networking',
    style: {
      top: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      alignItems: 'center',
    },
  },
  {
    key: 'persuasion',
    style: { top: 67, right: 12 },
  },
  {
    key: 'confidence',
    style: { bottom: 67, right: 12 },
  },
  {
    key: 'smallTalk',
    style: {
      bottom: 0,
      left: '50%',
      transform: 'translateX(-50%)',
      alignItems: 'center',
    },
  },
  {
    key: 'leadership',
    style: { bottom: 67, left: 12 },
  },
  {
    key: 'speaking',
    style: { top: 67, left: 12 },
  },
]

const SkillsChartCommunication = (props: TPageProps) => {
  const { nextPagePath, pageId } = props
  const { t } = useTranslation('communication')

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: QUESTION,
  })

  return (
    <S.Root>
      <S.ContentWrapper $gap={32}>
        <S.TitleGroup>
          <S.Title>
            <Trans
              ns="communication"
              i18nKey="onboarding.communicationSkillsChart.title"
            />
          </S.Title>

          <S.Subtitle>
            <Trans
              ns="communication"
              i18nKey="onboarding.communicationSkillsChart.subtitle"
            />
          </S.Subtitle>
        </S.TitleGroup>

        <S.ChartContainer>
          <picture>
            <source srcSet={skillsChartWEBP} type="image/webp" />
            <img src={skillsChartPNG} alt="Skills chart" />
          </picture>

          <S.Circle />

          {STATS.map(({ key, style }) => (
            <S.StatOverlay key={key} style={style}>
              <S.StatPercent>
                {t(`onboarding.communicationSkillsChart.stats.${key}.percent`)}
              </S.StatPercent>
              <S.StatLabel>
                {t(`onboarding.communicationSkillsChart.stats.${key}.label`)}
              </S.StatLabel>
            </S.StatOverlay>
          ))}
        </S.ChartContainer>

        <S.Button type="button" onClick={() => handleContinue('')}>
          <Trans i18nKey="actions.continue" />
        </S.Button>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default SkillsChartCommunication
